<cipo-dialog-header title="formulas.test.title" />
<mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="16px" style="padding: 8px 0">
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ "formulas.formula" | translate }}</mat-label>
            <input matInput [value]="dialogData.formula" readonly />
        </mat-form-field>
        <div>
            <span style="font-weight: 500">{{ "formulas.test.enterTestValues" | translate }}</span>
        </div>
        @for (field of dialogData.usedFieldIds; track field) {
            <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{ dialogData.fieldDetailsMap.get(field)?.label || field }}</mat-label>
                <input
                    matInput
                    [formControl]="testFieldValues[field]"
                    [placeholder]="'formulas.test.placeholder' | translate: { field: field }" />
                <mat-hint>{{ "formulas.test.hint" | translate }}</mat-hint>
            </mat-form-field>
        }
        @if (testResult !== null) {
            <mat-card class="test-result-card">
                <mat-card-content>
                    <div class="test-result">
                        <strong>{{ "formulas.test.result" | translate }}</strong>
                        <span class="result-value">{{ testResult }}</span>
                    </div>
                </mat-card-content>
            </mat-card>
        }
        @if (testError) {
            <div class="mat-caption text-warn" style="color: #d32f2f; margin-top: 8px">
                <mat-icon style="vertical-align: middle">error_outline</mat-icon>
                <span>{{ testError }}</span>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ "general.cancel" | translate }}</button>
    <button mat-raised-button color="primary" (click)="executeTest()">
        {{ "formulas.test.executeTest" | translate }}
    </button>
</mat-dialog-actions>
